module.exports = __webpack_public_path__ + "static/img/ENG-shield-logo.597e71e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ENG-shield-logo.svg
// module id = B1lf
// module chunks = 1